import { switchChain } from '@lair-finance/wagmi/core'
import { wagmiConfig } from '@/app/providers/wagmi'

export const wagmiSwitchChain = (chainId: number) => switchChain(wagmiConfig, { chainId })
